const headerNavLinks = [
  { href: '/', title: 'Home' },
  { href: '/digitalizza-il-tuo-menu', title: 'Digitalizza il tuo menu' },
]

export default headerNavLinks
